// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] .echope-product {\n  background-color: #e7e7e7 !important;\n}\n", ""]);
// Exports
module.exports = exports;
